import {currentYear} from "../../../utils/currentYear";
import "./footer.css";

const Footer = () => {
    return (
      <>
        <footer className="text-white text-center fw-bold position-absolute bottom-0">
          &copy; {currentYear()} Bola Nabil - All rights reserved.
        </footer>
      </>
    );
}

export default Footer;

